import { BuildingDTO } from "shared/types/building";
import { EasementCheckStatus } from "shared/types/ownership-info";

export const calculateEasementsDotValues = async (building: BuildingDTO) => {
  const dotValues: any = {
    red: { count: 0, labels: [] as any[] },
    orange: { count: 0, labels: [] as any[] },
    green: { count: 0, labels: [] as any[] },
    transparent: { count: 0, labels: [] as any[] },
  };

  const ownershipInfo: any = (building as any)?.buildingOwnershipInfo || {};
  const easements: any[] = Array.isArray(ownershipInfo?.easements)
    ? ownershipInfo.easements
    : [];

  const easementCount = easements.length;

  if (easementCount > 0) {
    dotValues.orange.count += 1;
    dotValues.orange.labels.push(`Erfdienstbaarheden aanwezig (${easementCount})`);
  } else {
    dotValues.transparent.count += 1;
    dotValues.transparent.labels.push("Geen erfdienstbaarheden");
  }

  if (
    ownershipInfo?.easementCheckStatus &&
    ownershipInfo.easementCheckStatus === EasementCheckStatus.OK
  ) {
    dotValues.green.count += 1;
    dotValues.green.labels.push(
      "Erfdienstbaarheden nagekeken in laatste notariële akte"
    );
  }

  return dotValues;
};


